import { Image as CoreImage } from '@starsoft/common/components';
import { RollCompetitionPrizeCellProps } from './props';
import styles from './styles.module.scss';
import { useRollCompetitions } from '@/api/roll-competitions';
import { WalletService } from '@starsoft/common/services';
import { getMoneyOrAmount } from '@starsoft/common/utils';

export default function RollCompetitionPrizeCell({
  prize,
}: RollCompetitionPrizeCellProps) {
  const { rollCompetition } = useRollCompetitions();

  if (prize.isZero()) {
    return null;
  }

  return (
    <div className={styles.container}>
      <CoreImage
        className={styles.container__image}
        width={14}
        height={14}
        secondarySkeleton
        src={
          rollCompetition
            ? `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${
                rollCompetition?.coin?.image ?? 'brl.svg'
              }`
            : undefined
        }
        alt={rollCompetition?.coin?.code}
      />
      {rollCompetition?.coin
        ? WalletService.maskCurrency({
            amount: getMoneyOrAmount(prize),
            coin: rollCompetition?.coin,
            hideSymbol: true,
          })
        : ''}
    </div>
  );
}
